import * as z from 'zod'
import { PrFilterKeyWordListItem, PrFilterKeyWordSingleItem } from '../PrFilterKeyword.js'
import { GetApiContract, PatchApiContract, PostApiContract } from './ApiContract.js'
import { schemaBoolish } from './zodUtils.js'

export interface GetPrFilterKeywordListItemRequest extends GetApiContract {
    Response: Array<PrFilterKeyWordListItem>
}

export interface GetPrFilterKeywordSingleItemRequest extends GetApiContract {
    Response: PrFilterKeyWordSingleItem
}

export const postPrFilterKeywordSchema = z.object({
    field: z.string(),
    language: z.string(),
    negation: schemaBoolish,
    phrase: z.string(),
})

export interface PostPrFilterKeywordRequest extends PostApiContract {
    Body: z.infer<typeof postPrFilterKeywordSchema>
    Response: PrFilterKeyWordSingleItem
}

export const patchPrFilterKeywordSchema = postPrFilterKeywordSchema

export interface PatchPrFilterKeywordRequest extends PatchApiContract {
    Body: z.infer<typeof patchPrFilterKeywordSchema>
    Response: PrFilterKeyWordSingleItem
}
